import styled from "styled-components";

export const CardStatus = styled.div`
    margin-top: 25px;
    text-align: center;
    position: absolute;
    z-index: 2;
    width: 100%;
`;